import { useQuery } from '@tanstack/react-query';

import { fetchPlanEntitlementsHistory, fetchPlanPriceHistory } from '../lib/plans-api';

export const planHistoryKeys = {
  all: (planId: string) => ['plan-history', planId] as const,
  price: (planId: string, filters: { field?: string } = {}) =>
    [...planHistoryKeys.all(planId), 'price', filters] as const,
  entitlements: (planId: string, filters: { action?: string } = {}) =>
    [...planHistoryKeys.all(planId), 'entitlements', filters] as const,
};

export function usePlanPriceHistory(planId: string | undefined, field?: string) {
  return useQuery({
    queryKey: planHistoryKeys.price(planId ?? '', { field }),
    queryFn: () => fetchPlanPriceHistory(planId as string, { field, limit: 50 }),
    enabled: Boolean(planId),
    staleTime: 30_000,
  });
}

export function usePlanEntitlementsHistory(
  planId: string | undefined,
  action?: 'added' | 'removed' | 'updated',
) {
  return useQuery({
    queryKey: planHistoryKeys.entitlements(planId ?? '', { action }),
    queryFn: () => fetchPlanEntitlementsHistory(planId as string, { action, limit: 50 }),
    enabled: Boolean(planId),
    staleTime: 30_000,
  });
}
